import { useRequestGetVerificationsCompleted } from '@/hooks/httpRequest';
import { useUrlParams } from '.';
import dayjs from 'dayjs';

const useVerifications = () => {

	const { date, page, type, sortType } = useUrlParams();
	const { data, verifications, isLoading: isLoadingVerifications, dataUpdatedAt, refresh } =
		useRequestGetVerificationsCompleted({
			date: dayjs(date).format('MM-DD-YYYY'),
			sortBy: 'updatedAt',
			sortType,
			page,
			type
		});

	return ({
		isLoadingVerifications,
		dataUpdatedAt,
		verifications,
		refresh,
		data
	});

};

export default useVerifications;
